import { render, staticRenderFns } from "./ModuleVersions.vue?vue&type=template&id=dee33734&"
import script from "./ModuleVersions.vue?vue&type=script&lang=js&"
export * from "./ModuleVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports